import { CloseOutlined } from "@mui/icons-material";
import { Dialog, IconButton } from "@mui/material";

import { getExtension } from "../../../../../components/ui library/helpers/functions";

export default function ViewDocumentModal({ viewDocument, closeDocModal, activeDoc }) {
  const fileExtension = getExtension(activeDoc.fileName);
  const isImage = ["png", "jpg", "jpeg", "gif", "webp", "bmp", "svg"].includes(
    fileExtension?.toLowerCase?.()
  );

  return (
    <Dialog open={viewDocument} fullScreen PaperProps={{ sx: { overflow: "hidden" } }}>
      <div className="flex h-screen flex-col overflow-hidden p-4 md:p-6">
        <div className="mb-4 flex shrink-0 justify-between">
          <IconButton onClick={closeDocModal}>
            <CloseOutlined />
          </IconButton>
        </div>
        <div className="min-h-0 flex-1 overflow-hidden">
          {(!activeDoc.file || fileExtension === "") && (
            <div className="flex h-full items-center justify-center">
              <p className="text-center text-xl font-bold">No File Preview Available</p>
            </div>
          )}
          {activeDoc.file && (
            <>
              {isImage ? (
                <img
                  src={activeDoc.file}
                  alt={activeDoc.fileName}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    display: "block",
                  }}
                />
              ) : (
                <object
                  data={activeDoc.file}
                  aria-label={activeDoc.fileName}
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "block",
                    border: "none",
                  }}
                ></object>
              )}
            </>
          )}
        </div>
      </div>
    </Dialog>
  );
}
